/**
 * Normalisation matière. Centralise la comparaison maths/français là où le code
 * mélangeait `===` strict, `.toLowerCase()` et la gestion de « mathématiques ».
 * NE PAS utiliser pour muter un paramètre de requête backend — uniquement pour
 * des comparaisons côté client.
 *
 * @param {string} m
 * @returns {string} 'maths' | 'français' | la valeur normalisée (trim+lowercase)
 */
export const normalizeMatiere = (m) => {
  const s = (m || '').toString().trim().toLowerCase();
  if (s.startsWith('math')) return 'maths';
  if (s.startsWith('fran')) return 'français';
  return s;
};

/** Comparaison de deux matières, insensible à la casse et aux variantes. */
export const matiereMatch = (a, b) => normalizeMatiere(a) === normalizeMatiere(b);
